import bindEvent from '../../scripts/util/event/bindEvent';
import isElement from '../../scripts/util/DOM/isElement';
import checkKey from '../../scripts/util/event/checkKey';

const selectors = {
	el: '.js-play',
	on: '.js-play-on',
	movie: '.js-play-video',
	video: '.js-play-popup',
	close: '.js-play-close'
};

const states = {
	hidden: 'hidden',
	visible: 'video-popup_visible'
};

const toggleState = (el, show = true) => {
	const video = el.querySelector(selectors.movie);
	const btn = el.querySelector(selectors.on);

	if (show) {
		el.classList.remove(states.hidden);
		el.classList.add(states.visible);
	}else {
		el.classList.add(states.hidden);
		el.classList.remove(states.visible);
		video.pause();
		video.removeAttribute('controls');
		btn.classList.remove(states.hidden);
	}
};

const show = e => {
	const target = e.currentTarget;
	const video = target.nextElementSibling;
	toggleState(video);
};

const hide = e => {
	const target = e.currentTarget;
	const video = target.closest(selectors.video);
	toggleState(video, false);
};

const onKeyPress = e => {
	const video = document.querySelector(`.${states.visible}`);
	if (checkKey(e) && video) {
		toggleState(video, false);
	}
};

const onPlay = e => {
	const target = e.currentTarget;
	const video = target.previousElementSibling;

	target.classList.add(states.hidden);
	video.play();
	video.setAttribute('controls', '');
};

const setHandlers = () => {
	bindEvent(selectors.el, 'click', show);
	bindEvent(selectors.close, 'click', hide);
	bindEvent(selectors.on, 'click', onPlay);
	document.addEventListener('keydown', onKeyPress);
};

const render = () => {
	if (isElement(selectors.el)) {
		setHandlers();
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/video-popup/index.js